import { ProcessDeUtil } from '../../domain/process-de-util';

export class ProcessVariable {
    id: string;
    name: string;
    documentation: string;
    basicType: string;
    tag: string;
    value: string;
    valueText: string;
    description: string;
    component: any;

    constructor() {
        this.id = ProcessDeUtil.GenerateElementId();
        this.basicType = 'String';
    }
}
